import { render, staticRenderFns } from "./AgendaPreview.vue?vue&type=template&id=dd12fcd2"
import script from "./AgendaPreview.vue?vue&type=script&lang=js"
export * from "./AgendaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports